import { QueryClient } from "@tanstack/react-query";

/**
 * Shared React Query client for the app.
 *
 * Defaults are tuned to match the previous hand-rolled caching behavior
 * (fetch-once-per-session, no background refetching): standards and similar
 * reference data rarely change within a session, so we avoid surprise refetches
 * on window focus / reconnect and let individual queries opt into shorter
 * staleness when they need it.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 min
    },
  },
});
